export const APPEND_SELECTOR = "body";

export const CLOSE_DELAY = 100;
